import PropTypes from 'prop-types';
import React from 'react';

import { usePdpContext } from '../../pdp-provider';

import isRemovable from '../../../../util/is-removable';
import Stepper from '../../../shared/stepper';

const QuantityStepper = ({
  categoryKeyPath,
  topLevelCategoryName,
  topLevelCategoryNumber,
  productOptionCategory,
  productOptionForm,
  productOptionNumber,
  useInactiveStyle,
}) => {
  const {
    isDemystifyMenuPdpEnabled,
    productOptionDefaults,
    selectedOptions,
    pricedSelectedOptions,
    updateProductOption,
  } = usePdpContext();
  const currentProductOptionDefaultsObject =
    productOptionDefaults[productOptionNumber];

  const preselectedOption = selectedOptions?.find(
    (option) => option.optionProductNumber === productOptionNumber
  );

  const productOptionPrice = isDemystifyMenuPdpEnabled
    ? pricedSelectedOptions?.get(preselectedOption?.size?.sku)
    : null;

  const productOptionName = productOptionForm?.name;

  const unitOfMeasure = productOptionCategory?.attributes?.unitOfMeasure
    ? `${productOptionName} ${productOptionCategory.attributes.unitOfMeasure}`
    : `${productOptionName}`;

  const onValueChange = (value) => {
    // Does this option have a sizeCode of 'no'?
    // This should only be applicable for options like Mocha Sauce,
    // which is a recipe option for the product. If the user set zero
    // on this type of option, the 'no' option
    // communicates this to the barista, ie. "No mocha sauce".
    const noSize = (productOptionForm?.sizes || []).find(
      (_size) => _size.sizeCode === 'no'
    );
    const size = value === 0 && noSize ? noSize : productOptionForm?.sizes?.[0];
    updateProductOption({
      // We are using categoryKeyPath value for the categoryKeypath arg in
      // this function call (notice the different casing of the letter p)
      // We plan to update all of these to use uppercase P categoryKeyPath
      // like the data we get from Graphql, but will followup on that.
      // Converting to the lowercase P makes this compatible with the original
      // PDP functionality.
      categoryKeypath: categoryKeyPath,
      formCode: productOptionForm.formCode,
      optionProductNumber: productOptionNumber,
      size,
      topLevelCategoryNumber,
      value,
    });
  };

  const currentAmount =
    typeof preselectedOption?.value === 'number'
      ? preselectedOption.value
      : currentProductOptionDefaultsObject?.inRecipe &&
        currentProductOptionDefaultsObject?.defaultValue;

  return (
    <Stepper
      className="pb2"
      currentQuantity={currentAmount}
      defaultQuantity={currentProductOptionDefaultsObject?.defaultValue}
      inRecipe={currentProductOptionDefaultsObject?.inRecipe}
      isDemystifyMenuPdpEnabled={isDemystifyMenuPdpEnabled}
      isRemovable={isRemovable({
        optionDefaults: currentProductOptionDefaultsObject,
        product: productOptionForm,
      })}
      onValueChange={onValueChange}
      productOptionForm={productOptionForm}
      productOptionName={productOptionName}
      productOptionNumber={productOptionNumber}
      productOptionPrice={productOptionPrice}
      topLevelCategoryName={useInactiveStyle ? null : topLevelCategoryName}
      unit={unitOfMeasure}
      useInactiveStyle={useInactiveStyle}
      validationId={`stepper-${productOptionNumber}`}
    />
  );
};

QuantityStepper.propTypes = {
  categoryKeyPath: PropTypes.array,
  topLevelCategoryName: PropTypes.string,
  productOptionCategory: PropTypes.object,
  productOptionForm: PropTypes.object,
  productOptionNumber: PropTypes.number,
};

export default QuantityStepper;
